var FcMaintenanceTypeModule = /** @class */ (function () {
    function FcMaintenanceTypeModule() {
    }
    return FcMaintenanceTypeModule;
}());
export { FcMaintenanceTypeModule };
